(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3374],{

/***/ 40714:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candylock",
      function () {
        return __webpack_require__(63855);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ candylock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/config/constants/supportChains.ts
var supportChains = __webpack_require__(47747);
// EXTERNAL MODULE: ./src/views/CandyLock/index.tsx + 1 modules
var CandyLock = __webpack_require__(72083);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 2 modules
var src = __webpack_require__(2216);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(23774);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(51071);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(95963);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 14 modules
var Toast = __webpack_require__(71999);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx + 1 modules
var useCatchTxError = __webpack_require__(57164);
// EXTERNAL MODULE: ./src/views/CandyLock/components/LockCard/LockCardHeader.tsx + 1 modules
var LockCardHeader = __webpack_require__(12670);
// EXTERNAL MODULE: ./src/views/CandyLock/hooks/helpers.ts
var helpers = __webpack_require__(26432);
// EXTERNAL MODULE: ./src/views/CandyLock/components/LockTimer.tsx
var LockTimer = __webpack_require__(60737);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/utils/getNftImageUrl.ts
var getNftImageUrl = __webpack_require__(62421);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/config/abi/candyLock.json
var candyLock = __webpack_require__(82753);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(97971);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(96273);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 13 modules
var wagmi = __webpack_require__(69330);
// EXTERNAL MODULE: ./src/views/CandyLock/types.ts
var CandyLock_types = __webpack_require__(62039);
;// CONCATENATED MODULE: ./src/views/CandyLock/hooks/useLockConfig.ts














// Retrieve Lock configuration
var useLockConfig = function() {
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var ref1 = (0,react.useState)({}), aprRates = ref1[0], setAprRates = ref1[1];
    var ref2 = (0,react.useState)({}), boostRates = ref2[0], setBoostRates = ref2[1];
    var ref3 = (0,react.useState)(bigNumber/* BIG_ZERO */.HW), minToken = ref3[0], setMinToken = ref3[1];
    var ref4 = (0,react.useState)(0), maxNft = ref4[0], setMaxNft = ref4[1];
    var ref5 = (0,react.useState)(false), blacklisted = ref5[0], setBlacklisted = ref5[1];
    var candyLockAddress = (0,addressHelpers/* getCandyLockAddress */.Kr)(chainId);
    (0,react.useEffect)(function() {
        var fetchConfiguration = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var client, contractCalls, result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            client = (0,wagmi/* publicClient */.z2)({
                                chainId: chainId
                            });
                            contractCalls = Object.keys(CandyLock_types/* LockDuration */.v).slice(0, 4).map(function(duration) {
                                return {
                                    abi: candyLock,
                                    address: candyLockAddress,
                                    functionName: "aprPerDuration",
                                    args: [
                                        duration
                                    ]
                                };
                            }).concat(Object.keys(types/* Rarity */.uq).slice(0, 5).map(function(rarity) {
                                return {
                                    abi: candyLock,
                                    address: candyLockAddress,
                                    functionName: "boostPerRarity",
                                    args: [
                                        rarity
                                    ]
                                };
                            }), [
                                {
                                    abi: candyLock,
                                    address: candyLockAddress,
                                    functionName: "minTokenPerLock",
                                    args: []
                                },
                                {
                                    abi: candyLock,
                                    address: candyLockAddress,
                                    functionName: "maxNftPerLock",
                                    args: []
                                }
                            ]);
                            _ctx.next = 4;
                            return client.multicall({
                                contracts: contractCalls,
                                allowFailure: false
                            });
                        case 4:
                            result = _ctx.sent;
                            setAprRates(result.slice(0, 4).reduce(function(acc, elem, index) {
                                // eslint-disable-next-line
                                // @ts-ignore
                                var acc_ = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, Object.values(CandyLock_types/* LockDuration */.v)[index], Number(elem)));
                                return acc_;
                            }, {}));
                            setBoostRates(result.slice(4, 9).reduce(function(acc, elem, index) {
                                // eslint-disable-next-line
                                // @ts-ignore
                                var acc_ = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, Object.keys(types/* Rarity */.uq)[index], Number(elem)));
                                return acc_;
                            }, {}));
                            setMinToken(new (bignumber_default())(result[9].toString()));
                            setMaxNft(Number(result[10]));
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchConfiguration() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchConfiguration();
    }, [
        candyLockAddress,
        chainId
    ]);
    (0,react.useEffect)(function() {
        var fetchBlacklisted = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var client, result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            client = (0,wagmi/* publicClient */.z2)({
                                chainId: chainId
                            });
                            _ctx.next = 3;
                            return client.readContract({
                                abi: candyLock,
                                address: candyLockAddress,
                                functionName: "accountBlocked",
                                args: [
                                    account
                                ]
                            });
                        case 3:
                            result = _ctx.sent;
                            setBlacklisted(result);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchBlacklisted() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account) fetchBlacklisted();
    }, [
        candyLockAddress,
        chainId,
        account
    ]);
    return {
        aprRates: aprRates,
        blacklisted: blacklisted,
        boostRates: boostRates,
        maxNft: maxNft,
        minToken: minToken
    };
};
/* harmony default export */ var hooks_useLockConfig = (useLockConfig);

// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(27892);
;// CONCATENATED MODULE: ./src/views/CandyLock/hooks/useLockReward.ts










// Retrieve reward from lock
var useLockReward = function(lockId, dependency) {
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var ref1 = (0,react.useState)(bigNumber/* BIG_ZERO */.HW), reward = ref1[0], setReward = ref1[1];
    var candyLockAddress = (0,addressHelpers/* getCandyLockAddress */.Kr)(chainId);
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function() {
        var fetchLockReward = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var client, rewardResult, rewardAmount;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            client = (0,wagmi/* publicClient */.z2)({
                                chainId: chainId
                            });
                            _ctx.next = 3;
                            return client.readContract({
                                abi: candyLock,
                                address: candyLockAddress,
                                functionName: "pendingReward",
                                args: [
                                    account,
                                    lockId
                                ]
                            });
                        case 3:
                            rewardResult = _ctx.sent;
                            rewardAmount = new (bignumber_default())(rewardResult.toString());
                            setReward(rewardAmount);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchLockReward() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account) fetchLockReward();
        else setReward(bigNumber/* BIG_ZERO */.HW);
    }, [
        candyLockAddress,
        account,
        chainId,
        lockId,
        dependency
    ]);
    return {
        reward: reward
    };
};
/* harmony default export */ var hooks_useLockReward = (useLockReward);

// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 9 modules
var useContract = __webpack_require__(16583);
;// CONCATENATED MODULE: ./src/views/CandyLock/hooks/useLockToken.ts





var useLockToken = function() {
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var lockContract = (0,useContract/* useCandyLockContract */.bN)();
    var onLock = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount, duration, nftIds, rarities, proofs) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockContract, "lock", [
                            amount,
                            duration,
                            nftIds,
                            rarities,
                            proofs
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(amount, duration, nftIds, rarities, proofs) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockContract,
        callWithGasPrice
    ]);
    var onClaim = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(lid) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockContract, "claimReward", [
                            lid
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lid) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockContract,
        callWithGasPrice
    ]);
    var onUnlock = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(lid) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockContract, "unlock", [
                            lid
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lid) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockContract,
        callWithGasPrice
    ]);
    return {
        onLock: onLock,
        onClaim: onClaim,
        onUnlock: onUnlock
    };
};
/* harmony default export */ var hooks_useLockToken = (useLockToken);

// EXTERNAL MODULE: ./src/views/CandyLock/components/Nft/NftItem.tsx
var NftItem = __webpack_require__(87425);
;// CONCATENATED MODULE: ./src/views/CandyLock/components/LockCard/LockCardDetails.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 12px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  display: flex;\n  margin-bottom: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin-left: ",
        ";\n  flex: 1;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  gap: 8px;\n  overflow-x: auto;\n  overflow-y: hidden;\n\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

















var StyledLockCardDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6b7a049-0"
})(_templateObject());
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6b7a049-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
var Display = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b6b7a049-2"
})(_templateObject2(), function(param) {
    var subHeader = param.subHeader;
    return subHeader ? "13px" : "15px";
}, function(param) {
    var subHeader = param.subHeader;
    return subHeader ? "8px" : "0px";
});
var NftRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6b7a049-3"
})(_templateObject3());
var LockCardDetails = function(param) {
    var data = param.data;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var candyToken = tokens_src/* cronosTokens.candy */.R7.candy;
    var ref = (0,react.useState)(false), status = ref[0], setStatus = ref[1];
    var lid = data.lid, lockAt = data.lockAt, duration = data.duration, amount = data.amount, nfts = data.nfts, unlocked = data.unlocked;
    var reward = hooks_useLockReward(lid, status).reward;
    var ref1 = hooks_useLockToken(), onClaim = ref1.onClaim, onUnlock = ref1.onUnlock;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref2 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref2.fetchWithCatchTxError, pendingTx = ref2.loading;
    var ref3 = hooks_useLockConfig(), aprRates = ref3.aprRates, boostRates = ref3.boostRates;
    var toggleStatus = function() {
        setStatus(!status);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLockCardDetails, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Lock Start Date")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "".concat(new Date(lockAt * 1000).toLocaleString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                timeZone: "UTC"
                            }), " (UTC)")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Lock End Date")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "".concat(new Date((lockAt + duration) * 1000).toLocaleString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                timeZone: "UTC"
                            }), " (UTC)")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Lock Amount")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                (0,formatBalance/* getBalanceNumber */.mW)(amount, candyToken.decimals).toLocaleString("en-US", {
                                    maximumFractionDigits: 3
                                }),
                                " ",
                                candyToken.symbol
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Boosting Nfts")
                        }),
                        nfts.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "No NFTs Locked"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                }),
                nfts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NftRow, {
                    children: nfts.map(function(nft) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NftItem/* default */.Z, {
                            id: nft,
                            image: (0,getNftImageUrl/* default */.Z)(nft)
                        }, "Boost NFT item - ".concat(nft));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("APR")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                (0,helpers/* getLockApr */.he)(aprRates, boostRates, duration, nfts),
                                " %"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Available Reward")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                (0,formatBalance/* getBalanceNumber */.mW)(reward, candyToken.decimals).toLocaleString("en-US", {
                                    maximumFractionDigits: 5
                                }),
                                " ",
                                candyToken.symbol
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    style: {
                        gap: "8px",
                        marginTop: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: pendingTx || reward.isEqualTo(bigNumber/* BIG_ZERO */.HW),
                            style: {
                                flex: "1"
                            },
                            onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var receipt;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return fetchWithCatchTxError(function() {
                                                return onClaim(lid);
                                            });
                                        case 2:
                                            receipt = _ctx.sent;
                                            if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                                toastSuccess("".concat(t("Claimed"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                                    txHash: receipt.transactionHash,
                                                    children: t("Claimed tokens have been sent to your wallet!")
                                                }));
                                                toggleStatus();
                                            }
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            children: "Claim Reward"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: pendingTx || unlocked || lockAt + duration > Date.now() / 1000,
                            style: {
                                flex: "1"
                            },
                            onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var receipt;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return fetchWithCatchTxError(function() {
                                                return onUnlock(lid);
                                            });
                                        case 2:
                                            receipt = _ctx.sent;
                                            if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                                toastSuccess("".concat(t("Unlocked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                                    txHash: receipt.transactionHash,
                                                    children: t("Unlocked tokens have been sent to your wallet!")
                                                }));
                                                toggleStatus();
                                            }
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            children: "Unlock"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var LockCard_LockCardDetails = (LockCardDetails);

;// CONCATENATED MODULE: ./src/views/CandyLock/components/LockCard/index.tsx



function LockCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 437px;\n  width: 100%;\n"
    ]);
    LockCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var StyledLockCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-81a49931-0"
})(LockCard_templateObject());
var LockCard = function(param) {
    var data = param.data, onUnlocked = param.onUnlocked;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.G)().account;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var candyToken = tokens_src/* cronosTokens.candy */.R7.candy;
    var amount = data.amount, duration = data.duration, lid = data.lid, lockAt = data.lockAt, unlocked = data.unlocked;
    var onUnlock = hooks_useLockToken().onUnlock;
    var ref1 = (0,react.useState)({
        status: null,
        currentTime: Math.floor(Date.now() / 1000)
    }), state = ref1[0], setState = ref1[1];
    var handleUnlock = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onUnlock(lid);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unlocked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Unlocked tokens have been sent to your wallet!")
                            }));
                            onUnlocked === null || onUnlocked === void 0 ? void 0 : onUnlocked();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUnlock() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var interval = setInterval((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var currentTime, status;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        currentTime = Math.floor(Date.now() / 1000);
                        status = (0,helpers/* getStatus */.lR)(currentTime, lockAt, duration);
                        setState({
                            status: status,
                            currentTime: currentTime
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })), 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        lockAt,
        duration
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLockCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
            style: {
                padding: "24px 16px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockCardHeader/* default */.Z, {
                    name: candyToken.name,
                    address: candyToken.address
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockTimer/* default */.Z, {
                    currentTime: state.currentTime,
                    duration: duration,
                    lockAt: lockAt,
                    unlocked: unlocked
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockCard_LockCardDetails, {
                    data: data
                })
            ]
        })
    });
};
/* harmony default export */ var components_LockCard = (LockCard);

// EXTERNAL MODULE: ./src/views/CandyLock/components/LockCards.tsx
var LockCards = __webpack_require__(90081);
;// CONCATENATED MODULE: ./src/views/CandyLock/hooks/useLockList.ts








// Retrieve Lock list
var useLockList = function(dependency) {
    var ref = (0,src/* useWeb3React */.G)(), account = ref.account, chainId = ref.chainId;
    var ref1 = (0,react.useState)([]), lockList = ref1[0], setLockList = ref1[1];
    var candyLockAddress = (0,addressHelpers/* getCandyLockAddress */.Kr)(chainId);
    (0,react.useEffect)(function() {
        var fetchLockList = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var client, countResult, lockCount, listResult;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            client = (0,wagmi/* publicClient */.z2)({
                                chainId: chainId
                            });
                            _ctx.next = 3;
                            return client.readContract({
                                abi: candyLock,
                                address: candyLockAddress,
                                functionName: "lockCount",
                                args: [
                                    account
                                ]
                            });
                        case 3:
                            countResult = _ctx.sent;
                            lockCount = Number(countResult);
                            _ctx.next = 7;
                            return client.readContract({
                                abi: candyLock,
                                address: candyLockAddress,
                                functionName: "viewLocks",
                                args: [
                                    account,
                                    0,
                                    lockCount
                                ]
                            });
                        case 7:
                            listResult = _ctx.sent;
                            // @ts-ignore
                            setLockList(listResult.map(function(data) {
                                return {
                                    lid: Number(data.lid),
                                    amount: new (bignumber_default())(data.amount.toString()),
                                    lockAt: Number(data.lockAt),
                                    duration: Number(data.duration),
                                    lastRewardAt: Number(data.lastRewardAt),
                                    unlocked: data.unlocked,
                                    nfts: data.nfts
                                };
                            }));
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchLockList() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account) fetchLockList();
        else setLockList([]);
    }, [
        candyLockAddress,
        account,
        chainId,
        dependency
    ]);
    return {
        lockList: lockList
    };
};
/* harmony default export */ var hooks_useLockList = (useLockList);

// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(85906);
;// CONCATENATED MODULE: ./src/views/CandyLock/hooks/usePromoCode.ts





// Retrieve promo code
var usePromoCode = function() {
    var account = (0,src/* useWeb3React */.G)().account;
    var handleFetchPromoCode = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(seed, sig) {
            var res, ref, json;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (account) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", "");
                    case 2:
                        _ctx.next = 4;
                        return fetch("".concat(endpoints/* BCC_API */.bI, "/promocode?account=").concat(account, "&seed=").concat(seed, "&sig=").concat(sig));
                    case 4:
                        res = _ctx.sent;
                        if (!res.ok) {
                            _ctx.next = 13;
                            break;
                        }
                        ;
                        _ctx.next = 9;
                        return res.json();
                    case 9:
                        json = _ctx.sent;
                        if (!(json.status === "success")) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return", json.data.code);
                    case 12:
                        throw (ref = json.data) === null || ref === void 0 ? void 0 : ref.error;
                    case 13:
                        return _ctx.abrupt("return", "");
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(seed, sig) {
            return _ref.apply(this, arguments);
        };
    }(), [
        account
    ]);
    return {
        handleFetchPromoCode: handleFetchPromoCode
    };
};
/* harmony default export */ var hooks_usePromoCode = (usePromoCode);

;// CONCATENATED MODULE: ./src/views/CandyLock/AllLocks.tsx



function AllLocks_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  border-radius: 8px;\n  border: 1px solid ",
        "88;\n  background: ",
        "22;\n  padding: 8px;\n\n  button {\n    margin-top: 4px;\n    border-width: 1px;\n    font-size: 13px;\n    font-weight: 500;\n  }\n"
    ]);
    AllLocks_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Banner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3018b9d8-0"
})(AllLocks_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
var AllLocks = function() {
    var ref = (0,react.useState)(false), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(""), promoCode = ref1[0], setPromoCode = ref1[1];
    var lockList = hooks_useLockList(status).lockList;
    var handleFetchPromoCode = hooks_usePromoCode().handleFetchPromoCode;
    var signMessageAsync = (0,src/* useSignMessage */.Q)().signMessageAsync;
    var toastError = (0,useToast/* default */.Z)().toastError;
    var toggleStatus = function() {
        setStatus(!status);
    };
    var onGetPromoCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var epochTime, sig, fetchedCode;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        epochTime = new Date().getTime();
                        _ctx.prev = 1;
                        ;
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return signMessageAsync({
                            message: "Generate one time promo code at ".concat(epochTime)
                        });
                    case 6:
                        sig = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        throw "User rejected request".toString();
                    case 12:
                        _ctx.next = 14;
                        return handleFetchPromoCode(epochTime, sig);
                    case 14:
                        fetchedCode = _ctx.sent;
                        setPromoCode(fetchedCode);
                        _ctx.next = 23;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t1 = _ctx["catch"](1);
                        console.error("Error ==> ", _ctx.t1);
                        setPromoCode("");
                        toastError("Error", _ctx.t1.toString());
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    18
                ],
                [
                    3,
                    9
                ]
            ]);
        }));
        return function onGetPromoCode() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockCards/* default */.Z, {
            isSingle: lockList.length === 0,
            children: lockList.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "center",
                mt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    scale: "lg",
                    children: "You do not have Lock."
                })
            }) : lockList.map(function(lockData) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LockCard, {
                    data: lockData,
                    onUnlocked: toggleStatus
                }, lockData.lid);
            })
        })
    });
};
/* harmony default export */ var CandyLock_AllLocks = (AllLocks);

;// CONCATENATED MODULE: ./src/pages/candylock/index.tsx




var CandyLockPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CandyLock_AllLocks, {});
};
CandyLockPage.Layout = CandyLock/* CandyLockLayout */.B4;
CandyLockPage.chains = supportChains/* SUPPORT_LOCK */.sT;
/* harmony default export */ var candylock = (CandyLockPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6309,9049,9774,2888,179], function() { return __webpack_exec__(40714); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);